import { render, staticRenderFns } from "./BVeeSelect.vue?vue&type=template&id=a918cb86&"
import script from "./BVeeSelect.vue?vue&type=script&lang=js&"
export * from "./BVeeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports